export default __webpack_public_path__ + "static/media/NTORQ 125 RT FI_3.e68bc9a2.webp";